<template>
  <div class="quality-rating-select">
    <div v-if="label" class="subheading mb-2" :class="labelClass">
      {{ label }}
    </div>
    <div class="d-flex align-center gap-2 mt-1">
      <v-rating
        :model-value="modelValue"
        :readonly="readonly"
        length="5"
        color="yellow-darken-2"
        active-color="yellow"
        empty-icon="mdi-star-outline"
        full-icon="mdi-star"
        :size="size"
        @update:model-value="onSelect"
      />
      <v-btn
        v-if="!readonly && modelValue > 0"
        icon
        variant="text"
        size="small"
        :color="clearButtonColor"
        @click="onSelect(0)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div
      v-if="showCaption"
      class="text-caption mt-1"
      :class="captionClass"
    >
      <span v-if="modelValue > 0">
        {{ modelValue }} {{ modelValue === 1 ? "star" : "stars" }}
      </span>
      <span v-else-if="placeholder">{{ placeholder }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "QualityRatingSelect",
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
    captionClass: {
      type: String,
      default: "text-grey",
    },
    clearButtonColor: {
      type: String,
      default: "grey",
    },
    size: {
      type: [Number, String],
      default: 32,
    },
    showCaption: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  methods: {
    onSelect(val) {
      if (this.readonly) return;
      const next =
        this.modelValue === val || val === 0 ? 0 : val;
      this.$emit("update:modelValue", next);
    },
  },
};
</script>
